import { Amplify } from "aws-amplify";


const DEFAULT_LOCALE = 'fr';
const SCOPES = ['aws.cognito.signin.user.admin','email', 'profile', 'openid']
/**
 * awsExports
 * This object contains the configuration for AWS Cognito authentication.
 */
export const awsExports = {
  Auth: {
      userPoolId: window.config.COGNITO_USER_POOL_ID,
      userPoolWebClientId: window.config.COGNITO_USER_POOL_CLIENT_ID,
      region: window.config.COGNITO_REGION,

      oauth: {
        domain: window.config.COGNITO_DOMAIN,
        scope: SCOPES,
        redirectSignIn: window.config.COGNITO_REDIRECT_SIGN_IN,
        redirectSignOut: window.config.COGNITO_REDIRECT_SIGN_OUT,
        responseType: 'code',
      },
  },
};


/**
 * CognitoLib
 * This class is a singleton that provides methods for signing in and signing out using AWS Cognito.
 * It uses the Amplify library to handle authentication.
 */
class CognitoLib {
  private static instance: CognitoLib;
  private constructor() {}

  public static getInstance(): CognitoLib {
    if (!CognitoLib.instance) {
      CognitoLib.instance = new CognitoLib();
    }
    return CognitoLib.instance;
  }

   /**
   * Initializes the CognitoLib instance with the provided configuration.
   */
  public init(): void {
    // Initialize Amplify with the provided configuration
    Amplify.configure(awsExports);
  }

  public async signIn(): Promise<void> {
        const { userPoolWebClientId } = awsExports.Auth
        const { domain, redirectSignIn , scope, responseType} = awsExports.Auth.oauth;
        const locale = DEFAULT_LOCALE;
        const scopesString = scope.join(' ')
        const queryString = Object.entries({
          redirect_uri: redirectSignIn,
          response_type: responseType,
          client_id: userPoolWebClientId,
          scope: scopesString,
          lang: locale
        })
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `https://${domain}/oauth2/authorize?${queryString}`;
        window.location.assign(url);
  }

}

const cognitoLib = CognitoLib.getInstance();

export { cognitoLib };